export default {
  'component.delBtn.title': 'Are you sure to delete?',
  'component.delBtn.tooltip': 'Delete',

  // Search form common labels
  'component.searchKeyword': 'Keyword',

  // 日期范围快捷选项(getDateRangePresets 消费,键名与 user-admin 用法同构)
  'component.dateRangePresets.today': 'Today',
  'component.dateRangePresets.yesterday': 'Yesterday',
  'component.dateRangePresets.thisWeek': 'This week',
  'component.dateRangePresets.thisMonth': 'This month',
  'component.dateRangePresets.last7Days': 'Last 7 days',
  'component.dateRangePresets.last30Days': 'Last 30 days',

  // 请求层框架文案(2026-09-28 收进内置 locales,键名与 user-admin 对齐)
  'request.error.loginExpiredTitle': 'Session Expired',
  'request.error.loginExpiredContent':
    'Your session has expired, please log in again.',
  'request.error.loginExpiredOkText': 'OK',
  'request.error.loginExpiringTitle': 'Session Expiring Soon',
  'request.error.loginExpiringContent':
    'Your session will expire in {minutes} minute(s). Please save your work.',
  'request.error.requestFailed': 'Request failed',
  'request.error.loginFailed':
    'Login failed, please check your account or password',
  'request.error.statusCode': 'Request failed, status code: {status}',
  'request.error.networkError': 'Network error, please check your connection',
  'request.error.unknownError': 'Request error, please try again',
};
